import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo-win.svg";
import loginImage01 from "../../assets/images/registration-page-image-01.png";
import loginImage02 from "../../assets/images/registration-page-image-02.png";
import loginImage03 from "../../assets/images/registration-page-image-01.png";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import ErrorModal from "../Security/ErrorModal";
import LanguageSelector from "../../Common/LanguageSelector";
import { useTranslation } from 'react-i18next';
import { Endpoints } from "../../Global/Endpoints";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setPartiallyVerified } from '../../Redux/verificationReducer';

const maskEmail = (email) => {
  if (!email || !email.includes("@")) return "";
  const [name, domain] = email.split("@");
  const maskedName = name.length <= 2
    ? name[0] + "*".repeat(Math.max(0, name.length - 1))
    : name.slice(0, 2) + "*".repeat(name.length - 2);

  const domainParts = domain.split(".");
  const domainName = domainParts[0];
  const domainMask = domainName.length <= 3
    ? domainName[0] + "*".repeat(Math.max(0, domainName.length - 1))
    : domainName.slice(0, 3) + "*".repeat(domainName.length - 3);

  return `${maskedName}@${domainMask}.${domainParts.slice(1).join(".")}`;
};

const maskPhone = (phone) => {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "");
  if (digits.length <= 4) return digits;
  return digits.slice(0, 2) + "*".repeat(digits.length - 4) + digits.slice(-2);
};

const ContractsForm = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch(); 
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showEmailPhoneOptions, setShowEmailPhoneOptions] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState("");
  const [maskedPhone, setMaskedPhone] = useState("");
  const [selectedContract, setSelectedContract] = useState("");  // State for selected contract
  const [memberId, setMemberId] = useState("");
  const [contractlist, setContractlist] = useState([]);
  const [combinedDataMemberId, setCombinedDataMemberId] = useState({});
  const [isGetStarted, setIsGetStarted] = useState("");
  const [isOkay, setIsOkay] = useState("");
  const [data, setData] = useState({});
 const [showErrorModal, setShowErrorModal] = useState(false);
 const [errorModalMessage, setErrorModalMessage] = useState("");
 const [combinedFormDataForModal, setCombinedFormDataForModal] = useState({});
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  const buildFormDataFromAccountData = (accountData = {}) => ({
    firstName: accountData.FirstName || "",
    lastName: accountData.LastName || "",
    preferredName: accountData.PreferredName || "",
    email: accountData.EmailID || "",
    password: accountData.PWD || "",
    confirmPassword: accountData.ConfirmPassword || "",
    agreeTerms: accountData.AgreeTerms || false,
    dateOfBirth: accountData.DOB || "",
  });

  const buildFormTwoDataFromAccountData = (accountData = {}) => ({
    phoneNumber: accountData.PhoneNo || "",
    agreeToTexts: accountData.TextNotificationStatus === "Yes",
    language: accountData.Language || "",
    raceEthnicity: accountData.Ethnicity || "",
  });

  const getRegistrationState = (accountData = {}, responseData = {}) => ({
    formData: location.state?.formData || buildFormDataFromAccountData(accountData),
    form2Data: location.state?.form2Data || buildFormTwoDataFromAccountData(accountData),
    form3Data: location.state?.form3Data || accountData.BenefitProvider || "",
    accessCode: location.state?.accessCode || accountData.Promocode || "",
    company: location.state?.company || accountData.Company || "",
    healthPlanID: location.state?.healthPlanID || accountData.HealthPlanId || "",
    otherData: { ...location.state?.otherData },
    createAccountResponseData: responseData,
  });


  useEffect(() => {

    const loadLogo = async () => {
      if (isHighmarkPortal) {
        const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
        setLogo(logoModule.default);
      } else {
        const logoModule = await import("./../../assets/images/win/logo-win.svg");
        setLogo(logoModule.default);
      }
    };

    loadLogo();
  }, [ssoData]);


   // Get the passed state (updatedFormData and apiResponse) from the previous component
   useEffect(() => {
    debugger
    if (location.state) {
      const { updatedFormData, apiResponse } = location.state;
      setCombinedDataMemberId(updatedFormData);
      setSelectedContract(updatedFormData.Contract || "");
      setMemberId(updatedFormData.MemberID || "");
      
      // Check if apiResponse and contractslist exist
      if (apiResponse ) {
        if(apiResponse.Contractlist) {
          setContractlist(apiResponse.Contractlist);
        }
        else{
         setContractlist(apiResponse);
         setSelectedContract(location.state.selectedContract || "");
         setMemberId(location.state.memberId || "");
        }
      } else {
        console.log("No contractslist available in apiResponse.");
      }
    }
  }, [location.state]);

  const handleBack = () => {
    const updated = { ...combinedDataMemberId, Contract: selectedContract, MemberID: memberId };
    setCombinedDataMemberId(updated);
    navigate("/companyname", { state: { combinedDataMemberId: updated } });
  }

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);

   // Handle contract selection
   const handleContractChange = (e) => {
    setSelectedContract(e.target.value);
  };

  // Handle member ID change
  const handleMemberIdChange = (e) => {
    setMemberId(e.target.value);
  };

  const handleEmailClick = () => {
    setShowModal(false);
    navigate('/forgotpassword', { state: { email: maskedEmail } });
  };

  const handlePhoneClick = async () => {
    try {
      const paramsObject = {
        EmailID: combinedFormDataForModal.EmailID,
        Phonenumber: combinedFormDataForModal.PhoneNo,
        FirstName: combinedFormDataForModal.FirstName,
        LastName: combinedFormDataForModal.LastName
      };

      await axios.post(
        Endpoints.TextForgotPassword,
        null,
        {
          params: { _Params: JSON.stringify(paramsObject) }
        }
      );

      setModalMessage("A temporary password has been sent to your registered phone number.");
      setShowEmailPhoneOptions(false);
      setShowModal(true);
    } catch (error) {
      setModalMessage("Failed to send temporary password. Please try again.");
      setShowEmailPhoneOptions(false);
      setShowModal(true);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();  // Prevent page refresh

    if (!selectedContract && !memberId) {
      setModalMessage("Please Select Contract and Enter memberID");
      setShowModal(true);
      return;
    } else if (!selectedContract) {
      setModalMessage("Please Select Contract");
      setShowModal(true);
      return;
    } else if (!memberId) {
      setModalMessage("Please Enter memberID");
      setShowModal(true);
      return;
    }

    // Update combinedDataMemberId with the selected contract, member ID, and benefit provider
  const updatedContractData = {
    ...combinedDataMemberId, // Spread existing data
    Contract: selectedContract, // Include selected contract
    MemberID: memberId, // Include member ID
  };

    // Set the updated combined data
    setCombinedDataMemberId(updatedContractData);
    setCombinedFormDataForModal(updatedContractData);
   // Prepare the _Params object
   const paramsObject = { ...updatedContractData ,
    EmployeeID: "",
    EmployeeFirstName: "",
    EmployeeLastName: "",
    RelationshiptoEmployee: ""};

   // Log the updated data before API call
   console.log("Updated Form Data with Access Code:", updatedContractData);
setLoading(true);
   // Make the API call
              try {
                const response = await axios.post(
                  Endpoints.CreateAccount,
                  null,
                  {
                    params: { _Params: JSON.stringify(paramsObject) },
                  }
                );
                // Handle the API response
                console.log("API Response:", response);
                if (response.data.Result === 2) {
                  console.log("Form submitted successfully:", paramsObject);
                  navigate("/registration-form-two", {
                    state: getRegistrationState(updatedContractData, response.data)
                  });
                } 
                 else if (response.data.Result === 7){
                console.log("Error or different result:", response.data.Message);
                // Navigate to the company name route with the updated form data
                setModalMessage(response.data.Message);
                setIsOkay(true)
                setShowModal(true);
              }
              else if (response.data.Result === 5){
                setShowErrorModal(true);
                setErrorModalMessage(response.data.Message);
              }
              else if (response.data.Result === 0){
                console.log("Error or different result:", response.data.Message);
                navigate("/registration-error");
              }
              else if (response.data.Result === 16) {
                const hiddenEmail = maskEmail(response.data.EmailID);
                const hiddenPhone = maskPhone(response.data.PhoneNumber);
                setIsGetStarted(false);
                setIsOkay(false);
                setMaskedEmail(response.data.EmailID || "your****@domain.com");
                setMaskedPhone(response.data.PhoneNumber || "123****7890");
                setModalMessage(`You have already registered and created an account with email ${hiddenEmail}. Please login with that account. Click on Email if you forgot your password and we will email it to you. If you do not have access to this email and would like a text to ${hiddenPhone}, please click on Phone to get the temporary password to the number.`);
                setShowEmailPhoneOptions(true);
                setShowModal(true);
              }
              else if (response.data.Result === 9){
                console.log("Form submitted successfully:", paramsObject);
                // Navigate to the next step on success
                setModalMessage(response.data.Message);
                //setIsGetStarted(true)
                setIsOkay(true)
                setShowModal(true);
              }
              } catch (error) {
                console.error("API Error:", error);
                // Navigate to companyname with the updated form data on API error
              } finally {
                setLoading(false);  }
            }

            const handleModalOkay = () => {
              setShowModal(false);
              if (isGetStarted) {
                setIsGetStarted(false);
                if(!isHighmarkPortal)
                {
 if(combinedDataMemberId.Country!="United States of America")
                  {
 navigate("/patientconsent-form", {state:  
                  combinedDataMemberId,responseData: data
                   });
                  }
                }
                  else
                  {
       const mergedFormData = { 
                          ...combinedDataMemberId, 
                          BabyCountFlag: data.BabyCountFlag 
                        };
   navigate("/healthprofilesetup", {state:  {combinedDataMemberId:mergedFormData}
                   });
                   dispatch(setPartiallyVerified());
                  }
              } else if (isOkay) {
                setIsOkay(false);
                //navigate("/");
                handleRedirect();
              }
            };
            const handleRedirect = () => {
              if (isHighmarkPortal) {
                sessionStorage.setItem("ssoRedirectInProgress", "true");
                sessionStorage.setItem("ssoBrand", "Highmark");
            
                setTimeout(() => {
                  dispatch({ type: "CLEAR_REDUX_STATE" });
                  dispatch({ type: "CLEAR_SSO_DATA" });
                  dispatch({ type: "LOGOUT" });
            
                  window.location.href = "https://www.highmark.com/member/member-guide";
                }, 100);
              } else {
                navigate("/login");
                dispatch({ type: "CLEAR_REDUX_STATE" });
                dispatch({ type: "CLEAR_SSO_DATA" });
                dispatch({ type: "LOGOUT" });
            
                sessionStorage.removeItem("highmarkSession");
              }
            };
            
             if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>
    {/* <div> <LanguageSelector /></div> */}
      {/* Header */}
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
          {isHighmarkPortal ? 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          : 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          }            
          </a>
        </nav>
      </header>

      <div className="registration-block-main">
        {/* left carousel start */}
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>
        {/* left carousel end */}

        {/* registration right form area start */}
        <div className="registration-form-main">
          <div className="registration-form">
            
                       <div className="registration-process-form-wrapper mt-5">
              <form>
              <div className="mb-3">
                  <label
                    htmlFor="language"
                    className="form-label win-form-label mandatory"
                  >
                    {t('contracttype')}
                  </label>
                  <select
                    id="language"
                    className="form-control win-form-control-a"
                    value={selectedContract}
                    onChange={handleContractChange}
                    >
                     <option value="">{t('selectcontract')}</option>
                    {contractlist?.length > 0 && contractlist.map((contracts, index) => (
                      <option key={index} value={contracts}>
                        {contracts} {/* Replace contract.name with appropriate field */}
                      </option>
                    ))}
                  </select>
                  {/* {errors.language && <div className="form-field-error-message">{errors.language}</div>} */}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="memberid"
                    className="form-label win-form-label"
                  >
                    {t('memberId')}
                  </label>
                  <input
                    type="text"
                    className="form-control win-form-control-a"
                    value={memberId}
                    onChange={handleMemberIdChange}  // Handle member ID input
                    required
                  />
                </div>
                
                <div className="mt-4 pagination-wrapper">
                  <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={handleBack}>{t('back')}</button>
                  <button className="win-btn-primary mobile-view" type="submit" onClick={handleSubmit}>
                  {t('verify')}
                  </button>
                </div>
                
              </form>
            </div>

          </div>
        </div>
        {/* registration right form area end */}
        <ErrorModal show={showModal} 
          message={modalMessage} 
          onClose={() => {
            setShowModal(false);
            setShowEmailPhoneOptions(false);
          }} 
          isGetStarted={isGetStarted}
          isOkay={isOkay}
          onOkay={handleModalOkay}
          showEmailPhoneOptions={showEmailPhoneOptions}
          maskedEmail={maskedEmail}
          maskedPhone={maskedPhone}
          onEmailClick={handleEmailClick}
          onPhoneClick={handlePhoneClick} 
          closeButton={true}
        />
        <ErrorModal
          show={showErrorModal}
          message={errorModalMessage}
          isOkay={true}
          onOkay={() => navigate("/eligibility", { state: { combinedDataMemberId, contractlist, selectedContract, memberId } })}
        />
      </div>        
    </>
  );
};
export default ContractsForm;
